import iconUrl from "#assets/icon.svg";
import { TOPBTN, TOPBTN_WARN } from "#puf/constants.ts";
import { store } from "#puf/store/index.ts";
import { useSelector } from "@xstate/store-react";

interface Props {
  assistantEnabled: boolean;
  assistantOpen: boolean;
  onToggleAssistant: () => void;
  onNew: () => void;
  onSave: () => void;
  onLoad: () => void;
  onUndo: () => void;
  onRedo: () => void;
  onExportPng: () => void;
  onExportSheet: () => void;
}

export function Topbar(props: Props) {
  const tab = useSelector(store, (s) => s.context.tab);
  const projectName = useSelector(store, (s) => s.context.projectName);

  return (
    <header className="flex flex-col gap-2 px-3 py-2 border-b border-line bg-bg-2 lg:flex-row lg:items-center lg:justify-between lg:gap-0 lg:py-0 lg:px-4 lg:h-14">
      <div className="flex items-center justify-between gap-3 lg:justify-start lg:gap-3.5">
        <div className="flex items-center gap-2 font-semibold tracking-widest text-accent shrink-0">
          <div
            aria-hidden
            className="relative w-6 h-6 lg:w-7 lg:h-7 bg-accent [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)] select-none pointer-events-none"
          >
            <img src={iconUrl} alt="" draggable={false} className="absolute inset-0 w-full h-full" />
          </div>
          <span className="text-[10px] lg:text-xs leading-[1.05] select-all max-w-min">
            PIXELPUF STUDIO
          </span>
        </div>
        <div className="flex">
          <button
            type="button"
            onClick={() => {
              store.trigger["tab.set"]({ tab: "canvas" });
            }}
            className={`px-3 py-1 lg:px-4.5 lg:py-1.5 border border-line cursor-pointer rounded-l-sm text-[11px] lg:text-xs ${
              tab === "canvas" ? "bg-accent text-bg font-semibold border-accent" : "bg-bg-3 text-text"
            }`}
          >
            Canvas
          </button>
          <button
            type="button"
            onClick={() => {
              store.trigger["tab.set"]({ tab: "state" });
            }}
            className={`px-3 py-1 lg:px-4.5 lg:py-1.5 border border-line cursor-pointer rounded-r-sm text-[11px] lg:text-xs ${
              tab === "state" ? "bg-accent text-bg font-semibold border-accent" : "bg-bg-3 text-text"
            }`}
          >
            <span className="lg:hidden">States</span>
            <span className="hidden lg:inline">State Machine</span>
          </button>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-1.5 lg:flex-nowrap lg:gap-2 lg:justify-end">
        <input
          type="text"
          id="project-name"
          name="project-name"
          value={projectName}
          onChange={(e) => {
            store.trigger["project.rename"]({ name: e.target.value });
          }}
          aria-label="Project name"
          className="flex-1 min-w-0 bg-bg-3 border border-line text-text px-2.5 py-1 lg:py-1.5 rounded-sm outline-none focus:border-accent lg:flex-none lg:w-36"
        />
        <button type="button" onClick={props.onNew} className={TOPBTN_WARN}>New</button>
        <button type="button" onClick={props.onSave} className={TOPBTN}>
          <span className="lg:hidden">Save</span>
          <span className="hidden lg:inline">Save .pxpf</span>
        </button>
        <button type="button" onClick={props.onLoad} className={TOPBTN}>Load</button>
        <button type="button" onClick={props.onUndo} className={TOPBTN}>Undo</button>
        <button type="button" onClick={props.onRedo} className={TOPBTN}>Redo</button>
        <button type="button" onClick={props.onExportPng} className={TOPBTN}>PNG</button>
        <button type="button" onClick={props.onExportSheet} className={TOPBTN}>Sheet</button>
        {props.assistantEnabled && (
          <button type="button" onClick={props.onToggleAssistant} className={TOPBTN}>
            {props.assistantOpen ? "Close AI" : "Assistant"}
          </button>
        )}
      </div>
    </header>
  );
}
